export default __webpack_public_path__ + "media/images/mailer-new/welcome/feature_moderation-c879ad045277991e94d14beb1237120b.png";